import get from 'lodash.get';
import { createSelector } from '../../../../utilities/reselect';

export const getPostSaleDetails = state => state.postSale;

export const getIsUserInPostSale = createSelector(getPostSaleDetails, postSale => {
  const isUserInPostSale = get(postSale, 'entities.isUserInPostSale', false);
  return isUserInPostSale;
});

export const getPurchasedVehicleStocknumber = createSelector(getPostSaleDetails, postSale => {
  const stockNumber = get(postSale, 'entities.purchasedVehicle.stockNumber', null);
  return stockNumber;
});

export const getIsPurchasedVehicleStocknumberAvailable = createSelector([getPurchasedVehicleStocknumber], stockNumber => {
  const isPurchasedVehicleStocknumberAvailable = Boolean(stockNumber);
  return isPurchasedVehicleStocknumberAvailable;
});

export const getPurchasedVehicleYear = createSelector(getPostSaleDetails, postSale => {
  const year = get(postSale, 'entities.purchasedVehicle.year', '');
  return year;
});

export const getPurchasedVehicleMake = createSelector(getPostSaleDetails, postSale => {
  const make = get(postSale, 'entities.purchasedVehicle.make', '');
  return make;
});

export const getPurchasedVehicleModel = createSelector(getPostSaleDetails, postSale => {
  const model = get(postSale, 'entities.purchasedVehicle.model', '');
  return model;
});

export const getIsYearMakeModelAvailable = createSelector([getPurchasedVehicleYear, getPurchasedVehicleMake, getPurchasedVehicleModel], (year, make, model) => {
  const isYearMakeModelAvailable = year && make && model;
  return isYearMakeModelAvailable;
});

export const getPurchasedVehicleYearMakeModel = createSelector([getIsYearMakeModelAvailable, getPurchasedVehicleYear, getPurchasedVehicleMake, getPurchasedVehicleModel], (isYearMakeModelAvailable, year, make, model) => {
  const yearMakeModel = isYearMakeModelAvailable ? `${year} ${make} ${model}` : '';
  return yearMakeModel;
});

export const getPurchasedVehicleTrim = createSelector(getPostSaleDetails, postSale => {
  const trim = get(postSale, 'entities.purchasedVehicle.trim', '');
  return trim;
});
